import TAGSORT, {taglist,related} from "../class/tagsort";
const [d] = [document];

const domReady = TPL => {
  const itemTemplate = `
    <div class="rwd002-list-content is-list-12" :class="[ 'is-paged-' + paged ]">
      <div class="rwd002-list-content__inner">
        <transition-group tag="ul" class="rwd002-list-content__list" name="fade" mode="out-in">
          <li class="rwd002-list-content__item" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
            <a :href="article.href" class="rwd002-list-content__link">
              <figure class="rwd002-list-content__thumb">
                <img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="rwd002-list-content__thumb-img">
                <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
              </figure>
              <div class="rwd002-list-content__body">
                <h5 class="title">{{ article.title }}</h5>
                <p class="tags" v-if="article.keywords && article.keywords.length">
                  <span class="tag" v-for="tag in article.keywords">#{{ tag }}</span>
                </p>
                <p class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</p>
              </div><!-- /.rwd002-list-content__body -->
            </a>
            <!-- /.rwd002-list-content__link -->
          </li>
          <!-- /.rwd002-list-content__item -->
        </transition-group>
        <!-- /.rwd002-list-content__list -->
      </div>
      <!-- /.rwd002-list-content__inner -->
    </div>
    <!-- /.rwd002-list-content -->
  `;
  const relatedItemTemplate = `
    <div class="rwd002-related-content is-list-12" v-if="relatedArticles.length">
      <div class="rwd002-related-content__inner">
        <h3 class="rwd002-related-content__title">関連記事</h3>
        <!-- /.rwd002-related-content__title -->
        <ul class="rwd002-related-content__list">
          <li class="rwd002-related-content__item" v-for="( article, ind ) in relatedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
            <a :href="article.href" class="rwd002-related-content__link">
              <figure class="rwd002-related-content__thumb">
                <img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="rwd002-related-content__thumb-img">
                <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
              </figure>
              <div class="rwd002-related-content__body">
                <h5 class="title">{{ article.title }}</h5>
                <p class="tags" v-if="article.keywords && article.keywords.length">
                  <span class="tag" v-for="tag in article.keywords">#{{ tag }}</span>
                </p>
                <p class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</p>
              </div><!-- /.rwd002-related-content__body -->
            </a>
            <!-- /.rwd002-related-content__link -->
          </li>
          <!-- /.rwd002-related-content__item -->
        </ul>
        <!-- /.rwd002-related-content__list -->
      </div>
      <!-- /.rwd002-related-content__inner -->
    </div>
    <!-- /.rwd002-related-content -->
  `;


  // taglistの拡張
  class taglist_custom extends taglist {
    insertContainer ( tag = `<taglist />`) {
      const pagination = d.querySelector( '.rwd002-pagination');
      const container = d.querySelector( this.opt.container || '.rwd002-container');
      const dispPos = d.body.classList.contains('is--list') ? this.opt.disp_list : this.opt.disp_detail;
      if( !container ) return false;
      switch ( dispPos ){
        case 'head': {
          container.insertAdjacentHTML('beforebegin', tag);
          break;
        }
        case 'foot': {
          if( pagination ) pagination.insertAdjacentHTML('afterend', tag);
          else container.insertAdjacentHTML('afterend', tag);
          break;
        }
        case 'append': {
          container.insertAdjacentHTML('beforeend', tag);
          break;
        }
        case 'prepend': {
          container.insertAdjacentHTML('afterbegin', tag);
          break;
        }
        case 'both':
        case true: {
          container.insertAdjacentHTML('beforebegin', tag);
          container.insertAdjacentHTML('afterend', tag);
          break;
        }
      }
    }
  }

  // relatedの拡張
  class related_custom extends related {
    insertContainer ( tag = `<related />`) {
      const pagination = d.querySelector( '.rwd002-pagination');
      const container = d.querySelector( this.opt.container || 'article.rwd002-detail');
      if( pagination && this.opt.disp_detail ) pagination.insertAdjacentHTML( 'afterend', tag );
      if( !pagination && container && this.opt.disp_detail ) container.insertAdjacentHTML('afterend', tag);
    }
  }

  const Tagsort = new TAGSORT({
    list: {
      perpage: 12, // 一度に表示する記事数
      itemTemplate
    },
    related: {
      disp_detail: true,
      itemTemplate: relatedItemTemplate,
      amount: 4
    },
    taglist: {
      disp_list: 'head', // head / foot / both(true) / append / prepend
    }
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
    Tagsort.related = new related_custom( TAGSORT.opt.related, TAGSORT );
  });

  Tagsort.render();

  // 詳細ページのタグ一覧
  const detail_taglist = () => {
    const tagsElm = d.querySelector( '.rwd002-detail__tags[data-tags]');
    const tags = tagsElm.dataset.tags.split(',');
    tags.forEach( tag => {
      const taglink = `<a href="/case/?mode=list&tag=${ encodeURI(tag) }" class="tag">#${tag}</a>`;
      tagsElm.insertAdjacentHTML('beforeend', taglink);
    } );
  }
  if( Tagsort.is_detail() ) detail_taglist();
};

const jqInit = () => false;

export default function CASE () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}